"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvalancheConfig = void 0;
const Tokens_1 = require("./Tokens");
const Types_1 = require("../../Types");
const MetamaskConnector_1 = require("../../Connectors/Wallets/MetamaskConnector");
const Utils_1 = require("../Utils");
const MetamaskCompatibleConnector_1 = require("../../Connectors/Wallets/MetamaskCompatibleConnector");
const Factory_1 = require("../../Connectors/Factory");
const WalletConnectConnector_1 = require("../../Connectors/Wallets/WalletConnectConnector");
exports.AvalancheConfig = Utils_1.blockchainConfigFactory({
    blockchain: Types_1.Blockchains.Avalanche,
    chainId: Types_1.EthChainIds.Avalanche,
    publicRpc: "https://api.avax.network/ext/bc/C/rpc",
    nativeToken: Tokens_1.AVAXNativeToken,
    wrappedToken: Tokens_1.AVAXWrappedToken,
    upToken: Tokens_1.AVAXUpToken,
    unfiToken: Tokens_1.AVAXUnfiToken,
    logoURI: "https://proxy.unifiprotocol.com/ipfs/QmWPVF97Jrf4QZZwsfgbViZRYFCqg8jyU3gH72QwLPTF64",
    multicall: {
        supported: true,
        address: "0xa00FB557AA68d2e98A830642DBbFA534E8512E5f",
        tryAggregate: false,
    },
    connectorFactory: Factory_1.web3ConnectorFactory,
    explorer: {
        baseUrl: "https://snowtrace.io",
        address: function (address) {
            return `${this.baseUrl}/address/${address}`;
        },
        token: function (address) {
            return `${this.baseUrl}/token/${address}`;
        },
        tx: function (address) {
            return `${this.baseUrl}/tx/${address}`;
        },
    },
}, [MetamaskConnector_1.MetamaskConnector, MetamaskCompatibleConnector_1.MetamaskCompatibleConnector, WalletConnectConnector_1.WalletConnectConnector], [
    Factory_1.createWeb3OfflineConnectorHelper(Types_1.OfflineConnectors.Avalanche, "https://api.avax.network/ext/bc/C/rpc"),
]);
